<template>
    <div class="qksm">
        <div class="nogap">
            <p><b>（六）市级财政专项资金预算安排情况（详见附表八）</b></p>
            <p v-if="num(T8.总计) == 0">
                2022年{{$parent.divname}}无市级财政专项资金预算。
            </p>
            <p v-else>
                2022年{{$store.state.divData.divname}}共安排市级专项资金3748.59万元，其中纳入本部门管理0万元，转移支付各县（市、区）3748.59万元。
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "qksm6",
        data() {
            return {
                isPdf: this.$parent.isPdf,
            }
        },
        props: {
            T8: {
                type: Object,
                default: "",
            },
        },
    };

</script>